// Define addressing modes as an enum for type safety
export enum AddressingMode {
    Immediate = 'immediate',
    ZeroPage = 'zeroPage',
    ZeroPageX = 'zeroPageX',
    ZeroPageY = 'zeroPageY',
    Absolute = 'absolute',
    AbsoluteX = 'absoluteX',
    AbsoluteY = 'absoluteY',
    Indirect = 'indirect',
    IndexedIndirect = 'indexedIndirect',
    IndirectIndexed = 'indirectIndexed',
    Implied = 'implied',
}

// Define flags for clarity
export enum Flag {
    Carry = 0x01,
    Zero = 0x02,
    InterruptDisable = 0x04,
    Decimal = 0x08,
    Break = 0x10,
    Unused = 0x20,
    Overflow = 0x40,
    Negative = 0x80,
}

// Define registers for type safety
export enum Register {
    A = 'A',
    X = 'X',
    Y = 'Y',
    SP = 'SP',
}

export interface Opcode {
    instruction: string;
    mode: AddressingMode;
    bytes: number;
    cycles: number;
    /** If true, add +1 cycle when the indexed addressing mode crosses a page. */
    pageCross?: boolean;
}